import { Component, OnInit } from "@angular/core";
import { FormField } from "../../../interfaces/form-field.model";
import { faPrint, faEraser } from "@fortawesome/free-solid-svg-icons";
import { formatDate } from "@angular/common";
import { NotifierService } from "angular-notifier";
import { COEBidsDetailsByDateReportService } from "src/app/services/autopac-reports/coe-bid-details-by-date-report.service";

@Component({
  selector: "coe-bids-details-by-date-report",
  templateUrl: "./coe-bids-details-by-date-report.component.html",
  styleUrls: ["./coe-bids-details-by-date-report.component.css"],
})
export class COEBidsDetailsByDateReportComponent implements OnInit {
  faPrint = faPrint;

  lockBtn = true;

  form!: FormField[];

  constructor(
    private notifier: NotifierService,
    private COEBidsDetailsByDateReportService: COEBidsDetailsByDateReportService,
  ) {}

  updateFields(event: any): void {
    this.form = event.fields;
    if (this.getFieldValue("StockAt")) {
      this.lockBtn = false;
    } else {
      this.lockBtn = true;
    }
  }

  ngOnInit() {
    this.setUpFormFields();
  }

  private setUpFormFields(): void {
    this.form = [
      {
        type: "radio",
        id: "Type",
        label: "Report Type",
        options: [
          {
            display: "Actual",
            value: "ActualCOEBidDate",
          },
          {
            display: "Less Taken By",
            value: "LessTakenByCOEBidDate",
          },
        ],
        value: "ActualCOEBidDate",
      },
      {
        type: "select",
        id: "BidFor",
        label: "Bid For",
        options: [
          {
            value: "ALL",
            display: "ALL",
          },
          {
            value: "K",
            display: "K",
          },
          {
            value: "C",
            display: "C",
          },
          {
            value: "P",
            display: "P",
          },
        ],
        value: "ALL",
      },
      {
        type: "date",
        id: "StockAt",
        label: "Stock At (dd/mm/yyyy)",
        required: true,
      },
      {
        type: "select",
        id: "Format",
        label: "Select Format",
        options: [
          {
            value: "pdf",
            display: "PDF",
          },
          {
            value: "excel",
            display: "EXCEL",
          },
          {
            value: "both",
            display: "BOTH",
          },
        ],
        value: "pdf",
      },
    ];
  }

  printStatus(): void {
    const searchData = this.populateSearchBody();
    this.COEBidsDetailsByDateReportService.COEBidsDetailsByDateReport(
      searchData,
    ).subscribe({
      next: (response) => {
        if (this.getFieldValue("Format") == "pdf") {
          window.open(response.body.Name, "_blank");
        } else if (this.getFieldValue("Format") == "excel") {
          window.open(response.body.Value, "_blank");
        } else if (this.getFieldValue("Format") == "both") {
          window.open(response.body.Value, "_blank");
          window.open(response.body.Name, "_blank");
        }
      },
      error: (error) => {
        console.log(error);
        this.handleError("Error getting data", error);
      },
    });
  }

  private populateSearchBody(): any {
    return {
      BidFor: this.getFieldValue("BidFor"),
      StockAt: formatDate(
        this.getFieldValue("StockAt"),
        "dd/MM/yyyy",
        "en-US",
      ),
      Type: this.getFieldValue("Type"),
    };
  }

  private getFieldValue(id: string, index?: number): any {
    const field = this.form.find((f) => f.id === id);
    return index !== undefined ? field?.value[index] : field?.value;
  }

  private handleError(message: string, error: any): void {
    console.error(message, error);
    this.notifier.notify("error", message);
  }
}
